let accessToken = localStorage.getItem('briefToken') || ''
export const setAccessToken = (token: string) => { accessToken = token; token ? localStorage.setItem('briefToken', token) : localStorage.removeItem('briefToken') }

export class ApiError extends Error { constructor(message: string, public readonly status: number) { super(message) } }
export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const isFormData = options.body instanceof FormData
  const response = await fetch(`/api${path}`, { ...options, headers: { ...(isFormData ? {} : { 'Content-Type': 'application/json' }), ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}), ...(options.headers || {}) } })
  const body = await response.json().catch(() => ({}))
  if (!response.ok) throw new ApiError(body.error || '请求失败', response.status)
  return body as T
}
